export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "data_source_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes brutes"])},
        "data_source_contracts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes avec produit sorti"])},
        "data_source_leads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulaires devoir de conseil"])}
      },
      "en": {
        "data_source_gross_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gross sales"])},
        "data_source_contracts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales with product output"])},
        "data_source_leads": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Advisory duty forms"])}
      }
    }
  })
}
